import React from "react";
import { Link } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const PLAN_LABELS = {
  basic: "Basic",
  standard: "Standard (Popular)",
  premium: "Premium",
};

export default function ActivePlanBadge() {
  const { user } = useAuth();
  if (!user || !user.plan) return null;
  const label = PLAN_LABELS[user.plan] || (user.plan.charAt(0).toUpperCase() + user.plan.slice(1));
  const isPopular = user.plan === "standard";

  return (
    <Link
      to="/dashboard/transactions"
      title="Your active subscription plan"
      className={`fixed bottom-4 left-4 z-40 inline-flex items-center gap-2 rounded-full px-3.5 py-2 text-xs font-semibold shadow-soft border transition-colors ${
        isPopular
          ? "bg-primary text-white border-primary/40 hover:bg-primary/90"
          : "bg-white text-ink border-border hover:bg-surface"
      }`}
      data-testid="active-plan-badge"
    >
      <BadgeCheck className={`h-4 w-4 ${isPopular ? "text-white" : "text-primary"}`} />
      <span className="whitespace-nowrap">
        Plan: <span className="font-bold" data-testid="active-plan-name">{label}</span>
      </span>
    </Link>
  );
}
